import { SpecificMicroFrontendProps } from '../../core';

export enum ControlTowerAccessContext {
  HOME = 'home',
  WIDGET = 'widget',
}

export const CONTROL_TOWER_ERP_SYNC_SETTLED_EVENT = 'control-tower-erp-sync-settled' as const;

export type ControlTowerErpSyncSettledOutcome = 'success' | 'error';

export interface ControlTowerErpSyncSettledEventDetail {
  outcome: ControlTowerErpSyncSettledOutcome;
  message: string;
}

export type ControlTowerGlobalPanelMicroFrontendProps = SpecificMicroFrontendProps & {
  onClose: () => void;
  onOccurrencesChanged?: () => void | Promise<void>;
  accessContext?: ControlTowerAccessContext;
};
